<div class="block p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 h-full">
    <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-2 border-b mb-2">
        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" (click)="toggleCollapse()">
            <button mat-icon-button *ngIf="collapsable">
                <mat-icon
                    class="icon-size-4 text-current"
                    [svgIcon]="!collapsed ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'"></mat-icon>
            </button>
            {{ headerTitle }}
        </h5>
        <ng-content select="actions" *ngIf="!collapsed"></ng-content>
    </div>


    <ng-content *ngIf="!collapsable || !collapsed"></ng-content>
</div>
